import { render, staticRenderFns } from "./Requestrewards.vue?vue&type=template&id=667f50ba"
import script from "./Requestrewards.vue?vue&type=script&lang=js"
export * from "./Requestrewards.vue?vue&type=script&lang=js"
import style0 from "./Requestrewards.vue?vue&type=style&index=0&id=667f50ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports